import { createSelector } from '@reduxjs/toolkit';

import { UndoStackState } from './undoStack.slice.types';

import { RootState } from '~/redux/store';

export const selectUndoIndex = ({
  undoStack,
}: RootState): UndoStackState['undoIndex'] => undoStack.undoIndex;

export const selectMaxUndoIndex = ({
  undoStack,
}: RootState): UndoStackState['maxUndoIndex'] => undoStack.maxUndoIndex;

export const selectUserDesignOperationsData = ({
  undoStack,
}: RootState): UndoStackState['userDesignOperationsData'] =>
  undoStack.userDesignOperationsData;

export const selectLastUserSelectedDesignOperation = createSelector(
  [
    ({ undoStack }: RootState) =>
      undoStack.userDesignOperationsData.selectedOperations,
  ],
  (
    userSelectedDesignOperations
  ):
    | UndoStackState['userDesignOperationsData']['selectedOperations'][number]
    | undefined =>
    userSelectedDesignOperations[userSelectedDesignOperations.length - 1]
);

export const selectDrawingShapeElementsStack = ({
  undoStack,
}: RootState): UndoStackState['drawingShapeElementsStack'] =>
  undoStack.drawingShapeElementsStack;
